module.exports = __webpack_public_path__ + "img/23.dde9e542.png";